import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "../ui/dialog";
import { api, orderRef } from "../../lib/api";

export const ProofViewer = ({ order, onClose }) => {
  const [urls, setUrls] = useState([]);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (!order) return undefined;
    let made = [];
    setUrls([]);
    setError(false);
    Promise.all((order.proofs ?? []).map((_, i) => api.get(`/admin/orders/${order.id}/proof/${i}`, { responseType: "blob" })))
      .then((rs) => {
        made = rs.map((r) => URL.createObjectURL(r.data));
        setUrls(made);
      })
      .catch(() => setError(true));
    return () => made.forEach((u) => URL.revokeObjectURL(u));
  }, [order]);

  return (
    <Dialog open={Boolean(order)} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="max-h-[92vh] overflow-y-auto rounded-none border-white/10 bg-[#0b0b11] text-white sm:max-w-2xl" data-testid="admin-proof-dialog">
        <DialogTitle className="font-display text-4xl font-normal uppercase">Payment proof · {order && orderRef(order.id)}</DialogTitle>
        <DialogDescription className="text-sm text-slate-400">Uploaded by the buyer. Screenshots can be faked — always confirm the money actually arrived in your Cash App, PayPal or wallet (right amount + reference) before marking paid.</DialogDescription>
        {error && <p className="text-sm text-[#ff7ad9]">Couldn't load the screenshots. Try again.</p>}
        {!error && !urls.length && <p className="font-mono text-xs uppercase tracking-widest text-slate-400">Loading…</p>}
        <div className="grid gap-3">
          {urls.map((u, i) => (
            <a key={u} href={u} target="_blank" rel="noreferrer" data-testid={`admin-proof-image-${i}`}>
              <img src={u} alt={`Payment proof ${i + 1}`} className="max-h-[70vh] w-full border border-white/10 object-contain" />
            </a>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
};
